export default function LoadingSpinner() {
  return (
    <div className="loadingBtn">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
